var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isOldBrowser
    ? _c("transition", [
        _c("div", { staticClass: "old-browser grid grid__custom-1" }, [
          _c("div", { staticClass: "old-browser--wrapper" }, [
            _c(
              "div",
              { staticClass: "old-browser--container grid--container" },
              [
                _c("h2", { staticClass: "old-browser--title" }, [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.title) +
                      "\n                "
                  )
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "old-browser--paragraph" }, [
                  _c("strong", [_vm._v(_vm._s(_vm.text))])
                ]),
                _vm._v(" "),
                _c("div", [
                  _c("h3", { staticClass: "old-browser--title u-reset__h4" }, [
                    _vm._v(
                      "\n                        " +
                        _vm._s(_vm.subtitle) +
                        "\n                    "
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "old-browser--btn-group" },
                    _vm._l(_vm.links, function(link, index) {
                      return _c(
                        "div",
                        { key: index, staticClass: "old-browser--btn-col" },
                        [
                          _c(
                            "a",
                            {
                              staticClass: "btn old-browser--btn btn__large",
                              attrs: { href: link.path }
                            },
                            [
                              _vm._v(
                                "\n                                " +
                                  _vm._s(link.label) +
                                  "\n                            "
                              )
                            ]
                          )
                        ]
                      )
                    }),
                    0
                  )
                ])
              ]
            )
          ])
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2e5ea7ca", { render: render, staticRenderFns: staticRenderFns })
  }
}